export const SectionTitle = ({ title }: { title: string }) => {
  return (
    <h2 className="text-lg mb-4 font-semibold capitalize text-[#838585]">
      {title}
    </h2>
  );
};
